function CtaD2() {
    const cards = document.querySelectorAll("[data-module='ctaD2'] .js-card");
    const buttons = document.querySelectorAll(
        "[data-module='ctaD2'] .js-card-button",
    );

    if (!cards.length) {
        return;
    }

    let isMobile = window.innerWidth < 768;

    function checkCardPosition() {
        isMobile = window.innerWidth < 768;
        if (!isMobile) {
            cards.forEach((card) => card.classList.remove('in-view'));
            return;
        }

        const viewportCenter = window.innerHeight / 2;

        cards.forEach((card) => {
            const rect = card.getBoundingClientRect();
            const inView =
                rect.top <= viewportCenter && rect.bottom >= viewportCenter;
            card.classList.toggle('in-view', inView);
        });
    }

    /**
     * Debounce function for performance optimization.
     * @param {function} func
     * @param {number} wait
     * @return {*}
     */
    function debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    const debouncedCheckCardPosition = debounce(checkCardPosition, 100);

    document.addEventListener('scroll', debouncedCheckCardPosition);
    window.addEventListener('resize', debouncedCheckCardPosition);

    buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => {
            if (isMobile) {
                return;
            }
            const card = button.closest('.js-card');
            if (card) {
                card.classList.add('in-view');
            }
        });

        button.addEventListener('mouseleave', () => {
            if (isMobile) {
                return;
            }
            const card = button.closest('.js-card');
            if (card) {
                card.classList.remove('in-view');
            }
        });
    });

    checkCardPosition();
}

export default CtaD2;
